function tgaSend(tgaItem) {

    var item = {};
    item['tid'] = tgaItem.tid;
    item['t'] = tgaItem.type;
    item['ua'] = navigator.userAgent;
    item['dl'] = document.location.origin + document.location.pathname + document.location.search;
    item['dt'] = document.title;

    var url = tgaItem.url;

    $.post(url, item);
}

jQuery(document).ready(function($) {

    if (typeof _tga === undefined) return;

    _tga.forEach(function(tgaItem){
        tgaSend(tgaItem);
    });

});